import axios from 'axios';
import { Resources } from '../types/Resources';
import { getResourceType } from './getResourceType';

export const PATH_TO_RESOURCES = '/nocache/i18n';

export interface Remote {
  fetch: (locale: string) => Promise<Resources>;
}

export const create = (packageName: string, namespace: string): Remote => ({
  fetch: async (locale: string) => {
    const resourceType = getResourceType();

    const url = `${PATH_TO_RESOURCES}/${resourceType}/${packageName}/${locale}/${namespace}.json`;

    const { data } = await axios.get<Resources>(url);

    return data;
  },
});
